import { ref } from 'vue'
import { defineStore } from 'pinia'
import type {
  UserClientDto,
  UserClientViewDto,
  UserClientCarrierDto,
  UserClientCountryDto,
  UserClientDimensionDto,
  UserClientServiceGroupDto,
  UserClientZipZoneDto,
} from '@/api/models/types'
import { userClientApi } from '../api/user-client.api'
import type { UserClientAction } from '../models/user.models'

export const useUserClientStore = defineStore('userClient', () => {
  const clientKey = ref<string>('')

  const getUserClients = async (): Promise<UserClientDto[]> => {
    const { data, error } = await userClientApi.getUserClients()
    if (!error && data) {
      return data
    }
    return []
  }

  const getUserClientActions = async (
    clientKey: string,
    userId?: number,
  ): Promise<UserClientAction[]> => {
    const { data, error } = await userClientApi.getUserClientActions(clientKey, userId)
    if (!error && data) {
      return data
    }
    return []
  }

  const getUserClientViews = async (
    clientKey: string,
    userId?: number,
  ): Promise<UserClientViewDto[]> => {
    const { data, error } = await userClientApi.getUserClientViews(clientKey, userId)
    if (!error && data) {
      return data
    }
    return []
  }

  const getUserClientCarriers = async (
    clientKey: string,
    userId?: number,
  ): Promise<UserClientCarrierDto[]> => {
    const { data, error } = await userClientApi.getUserClientCarriers(clientKey, userId)
    if (!error && data) {
      return data
    }
    return []
  }

  const getUserClientCountries = async (
    clientKey: string,
    userId?: number,
  ): Promise<UserClientCountryDto[]> => {
    const { data, error } = await userClientApi.getUserClientCountries(clientKey, userId)
    if (!error && data) {
      return data
    }
    return []
  }

  const getUserClientDimension = async (
    clientKey: string,
    id: number,
    userId?: number,
  ): Promise<UserClientDimensionDto[]> => {
    const { data, error } = await userClientApi.getUserClientDimension(clientKey, id, userId)
    if (!error && data) {
      return data
    }
    return []
  }

  const getUserClientServiceGroups = async (
    clientKey: string,
    userId?: number,
  ): Promise<UserClientServiceGroupDto[]> => {
    const { data, error } = await userClientApi.getUserClientServiceGroups(clientKey, userId)
    if (!error && data) {
      return data
    }
    return []
  }

  const getUserClientZipZones = async (
    clientKey: string,
    userId?: number,
  ): Promise<UserClientZipZoneDto[]> => {
    const { data, error } = await userClientApi.getUserClientZipZones(clientKey, userId)
    if (!error && data) {
      return data
    }
    return []
  }

  return {
    clientKey,
    getUserClients,
    getUserClientViews,
    getUserClientActions,
    getUserClientCarriers,
    getUserClientCountries,
    getUserClientDimension,
    getUserClientServiceGroups,
    getUserClientZipZones,
  }
})
